<template>
  <b-container fluid>
    <template v-if="optionsLoaded">
      <b-select v-if="isAdmin || isSRC" v-model="coordId" @change="switchOption();" class="mb-4">
        <b-select-option value="">Choose Regional Coordinator...</b-select-option>
        <b-select-option-group v-for="country, label in coordinators" :label="label" :key="label">
          <b-select-option v-for="coordinator in country" :value="coordinator.uuid" :key="coordinator.uuid">{{ `${coordinator.first_name} ${coordinator.last_name}` }}</b-select-option>
        </b-select-option-group>
      </b-select>
    </template>
    <activity-summary type="rc" v-bind:id="coordId" :key="coordId"></activity-summary>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ActivitySummary from '@/components/ActivitySummary';

export default {
  name: 'CountryActivity',
  components: {
    ActivitySummary,
  },
  data() {
    return {
      coordId: '',
      urlParams: new URLSearchParams(window.location.search),
      optionsLoaded: false,
      // getCoordinatorUuid: "b46dfd78-3572-41bb-b846-9fc2f9283c73", // for testing RC own login
    }
  },
  created() {
    this.getOptions();
    if (this.getCoordinatorUuid) {
      this.coordId = this.getCoordinatorUuid;
      this.$store.state.coordinators.coordinators.forEach(coord => {
        if (coord.uuid == this.getCoordinatorUuid) {
          this.country = coord.country;
        }
      });
    } else if (this.urlParams.get('coord_id') !== null) {
      this.coordId = this.urlParams.get('coord_id');
    }
  },
  methods: {
    ...mapActions({
      GET_COORDINATORS: "coordinators/GET_COORDINATORS",
    }),
    async getOptions() {
      try {
        await this.GET_COORDINATORS();

        this.optionsLoaded = true;
      } catch (err) {
        console.error(err);
      }
    },
    setUrlParam(param, value) {
      this.urlParams.set(param, value);
      window.history.replaceState({}, '', `${location.pathname}?${this.urlParams}`);
    },
    deleteUrlParam(param) {
      this.urlParams.delete(param);
      window.history.replaceState({}, '', `${location.pathname}?${this.urlParams}`);
    },
    switchOption() {
      if (this.coordId) {
        this.setUrlParam('coord_id', this.coordId);
      } else {
        this.deleteUrlParam('coord_id');
      }
    },
  },
  computed: {
    ...mapGetters({
      getCoordinatorUuid: "auth/getCoordinatorUuid",
      isAdmin: "auth/isAdmin",
      isSRC: "auth/isSRC",
    }),
    coordinators: {
      get() {
        if (!this.$store.state.coordinators.coordinators) { return []; }
        let coordinators = {};
        this.$store.state.coordinators.coordinators.forEach(coord => {
          if (!coordinators[coord.country]) {
            coordinators[coord.country] = [];
          }
          coordinators[coord.country].push(coord);
        });
        return coordinators;
      },
    },
  },
};
</script>
